var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"family-donut"},[_c('div',{staticClass:"outer",style:({backgroundColor: _vm.family.color, backgroundImage: `url(${_vm.family.imageUrl})`})}),_c('div',{staticClass:"inner",style:({background: _vm.subfamily.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }